import { render } from "./index.vue?vue&type=template&id=733166a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=733166a4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-733166a4"

export default script